import React from 'react';
import classNames from 'classnames';

import styles from './course-action.module.scss';
import RippleButton from '../../HomePage/HeroSection/RippleButton';

export function StartMyCourseBtn({ className, goToMyCourse }) {
  return (
    <RippleButton
      onClick={goToMyCourse}
      className={classNames(styles.startCourseBtn, className)}
      rippleColor="#fff"
      opacity={0.52}
    >
      Start My Course
    </RippleButton>
  );
}

export function CourseActionButton({
  className, userDetails, onClick, goToMyCourse,
  handleEmiRepayment, withEmiButton,
}) {
  // Free Course
  if (parseInt(userDetails?.isCourseFree, 10) === 1) {
    return <StartMyCourseBtn className={className} goToMyCourse={goToMyCourse} />;
  }

  // If Course not Purchased
  // if (parseInt(userDetails?.purchased, 10) === 0) {
  //   return (
  //     <RippleButton
  //       className={classNames(styles.buyNowBtn, className)}
  //       rippleColor="#fff"
  //       opacity={0.52}
  //       onClick={() => onClick(1)}
  //     >
  //       Buy Now
  //     </RippleButton>
  //   );
  // }

  if (parseInt(userDetails?.purchased, 10) === 1 && parseInt(userDetails?.validityLeft, 10) === 1) {
    return <StartMyCourseBtn className={className} goToMyCourse={goToMyCourse} />;
  }

  // Handle EMI Payment
  if (
    parseInt(userDetails?.purchased, 10) === 1 &&
    parseInt(userDetails?.paymentType, 10) === 2 &&
    parseInt(userDetails?.validityLeft, 10) === 0 &&
    parseInt(userDetails?.totalPaidEmi, 10) !== parseInt(userDetails?.totalEmi, 10)
  ) {
    return (
      <RippleButton
        className={classNames(styles.buyNowBtn, className)}
        rippleColor="#fff"
        opacity={0.52}
        onClick={handleEmiRepayment}
      >
        Pay EMI
      </RippleButton>
    );
  }

  // Handle Renew
  if (parseInt(userDetails?.purchased, 10) === 1 && parseInt(userDetails?.validityLeft, 10) === 0) {
    return (
      <RippleButton
        className={classNames(styles.buyNowBtn, className)}
        rippleColor="#fff"
        opacity={0.52}
        onClick={() => onClick(2)}
      >
        Renew
      </RippleButton>
    );
  }

  if (withEmiButton) {
    return (
      <div className={styles.actionButtonsWrapper}>
        <RippleButton
          className={classNames(styles.buyNowBtn, className)}
          rippleColor="#fff"
          opacity={0.52}
          onClick={() => onClick(1)}
        >
          Buy Now
        </RippleButton>

        <RippleButton
          className={classNames(styles.availWithEmi, className)}
          rippleColor="#fff"
          opacity={0.52}
          onClick={() => onClick(3)}
        >
          <b>Avail with EMI</b>
          <span>9 Months Plan</span>
        </RippleButton>
      </div>
    );
  }

  return (
    <RippleButton
      className={classNames(styles.buyNowBtn, className)}
      rippleColor="#fff"
      opacity={0.52}
      onClick={() => onClick(1)}
    >
      Buy Now
    </RippleButton>
  );
}
